import React, { useState, useEffect } from "react";
import { Input } from "semantic-ui-react";
import { toast } from "react-toastify";
import { usePayment } from "../../../../hooks";

// Propina que el comensal dejó en la mesa: la declara el mozo (o la Caja) antes
// de cobrar. Va fuera de la venta: no suma al total ni lleva IGV. Se guarda al
// salir del campo, así el cajero la ve ya anotada.
export function TipForm({ payment, onSaved }) {
  const { setPaymentTip } = usePayment();
  const [cash, setCash] = useState(String(Number(payment.tip_cash || 0) || ""));
  const [card, setCard] = useState(String(Number(payment.tip_card || 0) || ""));
  // Cada campo se sincroniza solo cuando cambia SU valor guardado: si se
  // guardara la de efectivo mientras se escribe la de tarjeta, esta no se borra.
  useEffect(() => {
    setCash(String(Number(payment.tip_cash || 0) || ""));
  }, [payment.tip_cash]);
  useEffect(() => {
    setCard(String(Number(payment.tip_card || 0) || ""));
  }, [payment.tip_card]);

  const save = async () => {
    const tipCash = Number(cash || 0);
    const tipCard = Number(card || 0);
    if (tipCash === Number(payment.tip_cash) && tipCard === Number(payment.tip_card)) return;
    try {
      onSaved(await setPaymentTip(payment.id, tipCash.toFixed(2), tipCard.toFixed(2)));
    } catch (error) {
      toast.error(error.message);
    }
  };

  const field = (label, value, setValue) => (
    <div style={{ flex: 1 }}>
      <label style={{ display: "block", fontWeight: 700, marginBottom: 4 }}>{label}</label>
      <Input
        fluid
        labelPosition="left"
        type="number"
        min="0"
        step="0.10"
        placeholder="0.00"
        value={value}
        onChange={(_, data) => setValue(data.value)}
        onBlur={save}
        label={{ basic: true, content: "S/" }}
      />
    </div>
  );

  return (
    <div style={{ marginBottom: 14 }}>
      <div style={{ display: "flex", gap: 10 }}>
        {field("Propina en efectivo", cash, setCash)}
        {field("Propina en tarjeta", card, setCard)}
      </div>
      <small style={{ color: "#777" }}>
        La propina no se suma a la cuenta ni lleva IGV.
      </small>
    </div>
  );
}
